import { render } from "./SurveyPage04.vue?vue&type=template&id=3453f0b3&scoped=true"
const script = {}

import "./SurveyPage04.vue?vue&type=style&index=0&id=3453f0b3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3453f0b3"]])

export default __exports__